import {
    apiRequest,
    presensiDetail,
    presensiListPresensi
} from "../../../../../services/adapters/kepegawaian/presensiService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", presensiDetail, {
            params: query
        }, true)
    }

    fetchListPresensi = async (query) => {
        return await apiRequest("get", presensiListPresensi, {
            params: query
        }, true)
    }
}

export default DetailRepository